const TOAST_TEMPLATES = {
  // Resume Import
  parsing_is_successful: 'Vos fichiers ont été importés, vous pouvez désormais les éditer sur Washi.',
  parsing_error: "L'import des fichiers n'a pas pu aboutir, nous vous invitons à ré-essayer.",
  content_too_long: "La section en cours est trop longue et n'a pu être sauvegardée. Veuillez raccourcir les textes.",
  pdf_files_not_added: "Les fichiers qui ne sont pas des PDF n'ont pas été ajoutés à la liste.",
  error_resume_upload: 'Une erreur est survenue durant le chargement du fichier. Veuillez ré-essayer.',
  error_resume_delete: 'Une erreur est survenue durant la suppression du fichier. Veuillez ré-essayer.',

  // Translation
  translation_failed: 'Une erreur est survenue lors de la traduction du dossier. Veuillez ré-essayer.',

  // Organization
  organization_created: "L'organisation a bien été créée.",
  organization_creation_failed: "L'organisation n'a pas pu être créée. Veuillez ré-essayer.",
};

export const actions = {
  addToastMsg({ state }, toast) {
    if (state.toastMessages.find(t => t.id === toast.id)) {
      return;
    }
    state.toastMessages.push(toast);
    setTimeout(() => {
      state.toastMessages = state.toastMessages.filter(t => t.id !== toast.id);
    }, 3000);
  },

  addSectionTooLongToast({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.content_too_long,
      type: 'alert',
      id: 'content_too_long',
    });
  },

  addWarnFileIsNotPdf({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.pdf_files_not_added,
      type: 'warning',
      id: 'one_file_is_not_pdf',
    });
  },

  addErrorResumeUpload({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.error_resume_upload,
      type: 'alert',
      id: 'error_resume_upload',
    });
  },

  addErrorResumeDelete({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.error_resume_delete,
      type: 'alert',
      id: 'error_resume_delete',
    });
  },

  parsingIsSuccessful({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.parsing_is_successful,
      id: 'parsing_is_successful',
    });
  },

  parsingHasFailed({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.parsing_error,
      type: 'alert',
      id: 'parsing_error',
    });
  },

  translationFailed({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.translation_failed,
      type: 'alert',
      id: 'translation_failed',
    });
  },

  organizationCreated({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.organization_created,
      id: 'organization_created',
    });
  },

  organizationCreationFailed({ dispatch }) {
    dispatch('addToastMsg', {
      msg: TOAST_TEMPLATES.organization_creation_failed,
      type: 'alert',
      id: 'organization_creation_failed',
    });
  },
};
